export const getAuthenticationCallbackUrl = () =>
	`${location.origin}/authenticate`
export const getLoginUrl = () =>
	`/auth/login?redirect_uri=${getAuthenticationCallbackUrl()}`
export const getAuthUrl = () =>
	`/auth/auth?redirect_uri=${getAuthenticationCallbackUrl()}`
